import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../../layout/layout.component';
import { PagerService } from '../../../common/pagerService';
import { CustomersSearchFields } from '../../../common/viewModels/Admin/CustomerModel';
import { CountryModel, LabsModel, PageResultDto } from '../../../common/viewModels/Admin/CustomerModel';
import { AmplifyService } from '../../../common/amplify-service';

@Component({
  selector: 'customerlist',
  templateUrl: './customerlist.component.html',
  styleUrls: ['./customerlist.component.scss']
})

export class CustomerList implements OnInit {
  customerSearchForm: FormGroup;
  searchFields: CustomersSearchFields = new CustomersSearchFields();
  isNoRecords: boolean = true;
  isSubmitted: boolean = false;
  pager: any = {};
  pagedItems: any[];
  id: number;
  lstCountries: CountryModel[];
  lstLabs: LabsModel[];
  pageResult: PageResultDto;
  length: number = 0;
  mainComponent: any;
  pageSize: number = 10;

  constructor(public _router: Router, private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute, private _pagerService: PagerService,
    private _mApp: MainAppComponent, private _toastrService: ToastrService, private _amplifyService: AmplifyService) {

    this.mainComponent = _mApp;
  }

  ngOnInit() {

    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
    this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
    this.pager.pageSize = this.pageSize;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
    this.CreateSearchForm();
    if (curUserDetails && curUserDetails.LabIds && curUserDetails.UserTypeId == 2) {
      this.customerSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
    }
    this.GetCountries();
    this.GetLabs();
    this.BindStaticSearchData();
    this.GetDataFromAmpliy();
    this.setPage(this.pager);
    this.ClearDataInAmplify();
  }

  CreateSearchForm() {
    this.customerSearchForm = this._formBuilder.group({
      Name: [''],
      LabIds: [''],
      CountryId: [''],
    });
  }

  GetCountries() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetCountries)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          this.lstCountries = data.json().Result;
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetLabs() {
    this._http.get(this._appUrl.GetLabsMinInfoList)
      .subscribe(
        data => {
          if(this._mApp.userTypeId == 2) {
            let lstLabs = data.json().Result;
            if (this._mApp.currentUserLabIds && lstLabs)
              lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
            this.lstLabs = lstLabs;
          }
          else {
            this.lstLabs = data.json().Result;
          }
        },
        error => {
          this._toastrService.error(error.json())
        }
      )
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetCustomersList(this.pager);
  }

  BindStaticSearchData() {
    this.searchFields.PageNo = 0;
    this.searchFields.PageSize = this._pagerService.globalPageSize;
  }

  onSubmit() {
    this.pager.pageIndex = 0;
    this.ConstructSearchData();
    this.setPage(this.pager);
  }

  ConstructSearchData() {
    let searchDto = this.customerSearchForm.value;
    this.searchFields.Name = searchDto.Name;
    this.searchFields.LabIds = searchDto.LabIds;
    this.searchFields.CountryId = searchDto.CountryId;
  }

  OnReset() {
    this.customerSearchForm.reset();
    this.searchFields.Name = '';
    this.searchFields.LabIds = [];
    this.searchFields.CountryId = 0;
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.CreateSearchForm();
    this.GetCountries();
    this.GetLabs();
    this.setPage(this.pager);
    if (this._mApp.userTypeId == 2) {
      var currentUser = JSON.parse(localStorage.getItem('currentUser'));
      let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
      this.customerSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
    }
  }

  GetCustomersList(page: any) {
    this._mApp.ShowLoader();
    this.searchFields.PageNo = page.pageIndex;
    this.searchFields.PageSize = page.pageSize;
    this._http.post(this._appUrl.GetCustomersList, this.searchFields)
      .subscribe(
        res => {
          var data = res.json();
          if (data != null) {
            this.length = data.PageResult.TotalRecords;
            this.pagedItems = data.Result;
            this.isNoRecords = !(data.Result.length > 0);
            this._mApp.HideLoader();
          }
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  DeleteCustomer(id: any) {
    this.id = id;
  }

  DeleteCustomersById(id: number) {
    this.SaveDataInAmplify();
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteCustomer + id)
      .subscribe(
        res => {
          this._mApp.HideLoader();
          this.GetDataFromAmpliy();
          this.setPage(this.pager);
          this._toastrService.success(res.json().Result, '');
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  SaveDataInAmplify() {
    this._amplifyService.SetStorage('customersList', this.customerSearchForm.value);
    this._amplifyService.SetStorage('customersList_PageNo', this.pager.pageIndex);
    this._amplifyService.SetStorage('customersList_PageSize', this.pager.pageSize);
  }


  GetDataFromAmpliy() {
    let storedData = this._amplifyService.GetStorage('customersList');
    if (storedData != undefined && storedData != null) {
      this.customerSearchForm.setValue(storedData);
      this.ConstructSearchData();
    }
    // let savedPageSize = this._amplifyService.GetStorage('customersList_PageSize');
    // this.pager.pageSize = savedPageSize > 0 ? savedPageSize : this._pagerService.pageSize;
    let pageIndex = this._amplifyService.GetStorage('customersList_PageNo');
    if (pageIndex != null && pageIndex != '' && pageIndex != undefined)
      this.pager.pageIndex = pageIndex;
    else
      this.pager.pageIndex = 0;
  }

  ClearDataInAmplify() {
    this._amplifyService.ClearStorage('customersList');
    this._amplifyService.ClearStorage('customersList_PageNo');
    this._amplifyService.ClearStorage('customersList_PageSize');
  }
}
